module.exports = __webpack_public_path__ + "static/media/NewPostButton_v2NoWords.1d82ae16.png";